import Pqp from "../../../3x1010/Pqp.js";
import Game from "../../Game.js";
import SpriteProvider from "../../utils/SpriteProvider.js";
import Control from "../controllers/Control.js";
import Spran from "../spran/Spran.js";
import Maze from "../../maze/Maze.js";
import BasicAI from "./ai/BasicAI.js";
import Screen from "../Screen.js";

export default class Mob {
	constructor(sprites, animationsDefinitions) {
		this.sprites = sprites;
		this.sp = new SpriteProvider(sprites);
		this._mc = null;
		this._width = -1;
		this._height = -1;
		this._cell = null;
		this._oldCell = null;
		this._cells = null;
		this._oldCells = null;
		this.id = Mob.ID++;
		this.clip = null;
		this.animationsDefinitions = animationsDefinitions;
		this.zindex = -1;
		this.defaultAnimation = null;
		this.clas = null;
		//this.speed = speed;
		this._top = 0;
		this._left = 0;
		this.race = "none";
		//if (!this.speed) {

		//}

		this._inView = false;
		this.openDoors = false;
		this.static = true;

		this.ai = null;
		this.controller = null;
		this.facing = Maze.DIR_S;
		this._warned = 0;
		this.warnCount = 0;
		this.inited = false;

		this.qi = BasicAI.QI_NONE;
		this.speed = Mob.WALK_STEP * Game.MULT;
		this.radius = Mob.RADIUS;
		this.runspeed = Mob.RUN_SPEED * Game.MULT;
		this.timeWarns = [250, 500]

		this.infoable = false;
		this.stackIndex = -1;
		this.spiked = false;
		this.invulnerable = false;
		this.spikedLevel = 0;
	}

	setMobTraits(o) {
		/*this.clas = o.clas;
		this.openDoors = o.openDoors;
		this.static = o.static;
		this.qi = o.qi;
		this.speed = o.speed;
		this.radius = o.radius;
		this.runspeed = o.runspeed;
		this.originalSpeed = this.speed;*/

		for (var prop in o) {
			this[prop] = o[prop];
		}

		this.originalSpeed = this.speed;
	}


	substAnimation(id, frame, props) {
		for (let x = 0; x < this.animationsDefinitions.length; x++) {
			if (this.animationsDefinitions[x].id == id) {
				let frames = this.animationsDefinitions[x].frames;
				for (var prop in props) {
					this.animationsDefinitions[x].frames[frame][prop] = props[prop];
				}
			}
		}
		//console.log(this.animationsDefinitions)
	}

	init() {

	}

	isWarned() {
		if (this.warned > 0) {
			return true;
		}
		return false;
	}

	checkController() {
		if (this.hasController()) {
			this.controller.startCheck();
		}

	}

	hasController() {
		if (this.controller) {
			return true;
		}
		return false;
	}

	getQI() {
		return this.qi;
	}


	setAI(ai) {
		this.ai = ai;
	}

	hasAI() {
		if (this.ai) {
			return true;
		}
		return false;
	}

	destroy() {
		if (this.spran) {
			this.spran.pause();
		}

	}

	dispose() {
		this.destroy();
		this.mc.remove();
	}

	position() {
		return { top: this.top, left: this.left };
	}

	isStatic() {
		return this.static;
	}
	isInView() {
		return this.inView;
	}
	canOpenDoors() {
		return this.openDoors;
	}

	get mc() {
		return this._mc;
	}
	set mc(value) {
		this._mc = value;
	}
	get top() {
		return this._top;
	}
	set top(value) {
		if (this.mc) {
			this.mc.css("top", value)
		}
		this._top = value;
	}
	get left() {
		return this._left;
	}
	set left(value) {
		if (this.mc) {
			this.mc.css("left", value)
		}

		this._left = value;
	}
	get width() {
		return this._width;
	}
	set width(value) {
		this._width = value;
	}
	get height() {
		return this._height;
	}
	set height(value) {
		this._height = value;
	}
	get cell() {
		return this._cell;
	}
	set cell(value) {
		this._cell = value;
	}
	get oldCell() {
		return this._oldCell;
	}
	set oldCell(value) {
		this._oldCell = value;
	}

	get cells() {
		return this._cells;
	}
	set cells(value) {
		this._cells = value;
	}
	get oldCells() {
		return this._oldCells;
	}
	set oldCells(value) {
		this._oldCells = value;
	}

	initSprites() {
		// Setta la grandezza dello sprite
		this.clip = jQuery(".js-sprite", this.mc);

		this.clip.width(Game.TILE_WIDTH_MAP * Game.MOB_SPRITE_WIDTH_MULT);
		this.clip.height(Game.TILE_HEIGHT_MAP * Game.MOB_SPRITE_HEIGHT_MULT);

		// Lo posiziona, centrato orizzontalmente e appoggiato al bottom verticalmente
		this.clip.css("left", (this.mc.width() - this.clip.width()) / 2);
		this.clip.css("top", -(Game.TILE_WIDTH_MAP - this.mc.height()) - Game.TILE_WIDTH_MAP + Game.HERO_HEIGHT / 2);

		this.emote = jQuery(".js-emote", this.mc);

		this.emote.width(Game.TILE_WIDTH_MAP * Game.MOB_SPRITE_WIDTH_MULT);
		this.emote.height(Game.TILE_HEIGHT_MAP * Game.MOB_SPRITE_HEIGHT_MULT);

		// Lo posiziona, centrato orizzontalmente e appoggiato al bottom verticalmente
		this.emote.css("left", (this.mc.width() - this.clip.width()) / 2);
		this.emote.css("top", -(Game.TILE_WIDTH_MAP - this.mc.height()) - Game.TILE_WIDTH_MAP + Game.HERO_HEIGHT / 2);
		this.emote.hide();

		this.spran = new Spran(this.sp, this.clip, this.animationsDefinitions);
		this.spran.init();
		this.setAnimation("idle");
		this.inited = true;

		if (this.infoable) {
			//jQuery(".js-hit-area", this.mc).on("click", this.getStackInfo.bind(this));
			//jQuery(".js-hit-area", this.mc).width(Game.TILE_WIDTH_MAP * Game.MOB_SPRITE_WIDTH_MULT);
			//jQuery(".js-hit-area", this.mc).height(Game.TILE_HEIGHT_MAP * Game.MOB_SPRITE_HEIGHT_MULT);
			this.setInfoable();
		} else {
			jQuery(".js-hit-area", this.mc).remove();
		}
	}

	setInfoable() {
		if (this.infoable) {
			jQuery(".js-hit-area", this.mc).on("click", this.getStackInfo.bind(this));
		}
	}

	getStackInfo() {
		Screen.that.showStackInfo(this);
	}

	isInvulnerable() {
		return this.invulnerable;
	}
	setInvulnerable(time) {
		this.invulnerable = true;
		setTimeout(this.stopInvulnerability.bind(this), time);
	}
	stopInvulnerability() {
		this.invulnerable = false;
	}

	setAnimation(id, callback) {
		if (this.spiked) {
			return;
		}
		let dir = id.indexOf("_");
		if (dir >= 0) {
			this.facing = id.charAt(dir + 1);
		} else {
			if (!this.isStatic()) {
				id += "_" + this.facing;
			}
		}

		if (Pqp.isNullOrEmpty(this.defaultAnimation)) {
			this.defaultAnimation = id;
		}
		if (this.hasAI()) {
			if (this.inView) {
				this.spran.setAnimation(id, callback);
			}
		} else {
			this.spran.setAnimation(id, callback);
		}
	}

	setZFromCell(cell, model) {
		// calcola lo z-index in base alla riga e lo aumenta in modo che sia superiore a tutta la riga (ma inferiore a quella successiva)
		//this.zindex = cell.row * 2 * model.cols + cell.col + model.rows;
		//this.zindex = cell.row * 10 * model.cols + cell.col + model.cols;
		this.zindex = cell.row * 2 * model.cols + cell.col + model.cols;

		//let z = this.cell.row * 10 * this.cell.model.cols + this.cell.col

		this.mc.css("z-index", this.zindex);
	}

	setZDirect(zindex) {
		this.zindex = zindex;
		this.mc.css("z-index", this.zindex);
	}

	setInView(lFlag) {
		if (lFlag) {
			//this.spran.resume();
			/*if (!this.inView) {
				if (this.hasAI()) {
					this.controller.stop();
					this.ai.stopAllDecisions();
				}
			}*/
			this.inView = true;
			this.spran.resume(this.defaultAnimation);
		} else {
			if (this.inView) {
				if (this.hasAI()) {
					this.controller.stop();
					this.ai.stopAllDecisions();
					this.ai.asleep = true;
				}
			}

			this.inView = false;
			this.spran.pause();
		}
	}

	pauseAnimation() {
		this.spran.pause();
	}
	resumeAnimation() {
		this.spran.resume(this.spran.pausedId);
	}

	getSpeed() {
		if (this.warned) {
			return this.runspeed;
		}
		//console.log(this.runspeed)
		return this.speed;
	}

	setSpeed(type) {
		if (type === Control.SPEED_NORMAL) {
			this.speed = this.originalSpeed;
		}
		if (type === Control.SPEED_SLOW) {
			this.speed = this.originalSpeed / 2;
		}
		if (type === Control.SPEED_VERY_SLOW) {
			this.speed = this.originalSpeed / 4;
		}
		if (type === Control.SPEED_FAST) {
			this.speed = this.originalSpeed * 2;
		}

	}

	get warned() {
		return this._warned;
	}
	set warned(value) {
		this._warned = value;
		if (value === 2) {
			let sprite = this.sp.getSprite("warned", 0, 1);
			this.emote.show();
			this.emote.css("background-image", "url('" + sprite + "')");
		} else if (value === 1) {
			this.emote.show();
			let sprite = this.sp.getSprite("warned", 0, 0);
			this.emote.css("background-image", "url('" + sprite + "')");
		} else {
			this.emote.hide();
		}

	}
	get inView() {
		return this._inView;
	}
	set inView(value) {
		this._inView = value
		if (this.inited) {
			if (!value) {
				this.warned = 0;
				this.warnCount = 0;
			}
		}
	}


	isHero() {
		if (this.clas === "hero") {
			return true;
		}
		return false;
	}

	isEnemy() {
		if (this.clas === "enemy") {
			return true;
		}
		return false;
	}



}

Mob.RADIUS = 3;
Mob.WALK_STEP = 4;
Mob.RUN_STEP = 4;
Mob.ID = 0;
Mob.ENUM = 0;